<!-- This allows us to set the above params from a constructor -->
<svelte:options accessors={true} />

<script>
  import Icon from "$lib/components/Icon.svelte";
  export let text;
  export let iconSize = "md";
  export let iconClass = "!inline ml-8 align-top";
  export let textClass = "underline";

  let singleWordWrapClass = "";

  function isolateLastWordForWrapping(text) {
    text = text.trim();
    let lastWord;
    let reducedText = "";

    text.split(" ").forEach((word, index, array) => {
      if (index !== array.length - 1) {
        reducedText += `${word} `;
      } else {
        lastWord = word;
      }
    });

    return { reducedText, lastWord };
  }

  const { reducedText, lastWord } = isolateLastWordForWrapping(text ?? "");

  if (!reducedText && lastWord) {
    singleWordWrapClass = "single-word-wrap";
  }
</script>

<span class="whitespace-normal">
  {#if text}
    <span class={textClass}>
      {reducedText}
    </span>
    <span class="whitespace-nowrap {singleWordWrapClass}">
      <span class={textClass}>
        {lastWord}
      </span>
      <Icon type="external" size={iconSize} class={iconClass} />
    </span>
  {/if}
</span>
<span class="sr-only">Opens in a new tab</span>

<!--This is a compromise until I can implement a better solution for NOT wrapping the text of an external
link that happens to be a really long word. The compromise is that I just won't apply the wrapping rules on
really small screens since it can cut off some of the text that refuses to wrap. - Christina -->
<style>
  @media (max-width: 400px) {
    .single-word-wrap {
      white-space: normal !important;
    }
  }
</style>
